import React from "react";
import Modal from "./Base/Modal";
import SuccessIcon from '../assets/icons/thumbs-up-success.png'

interface PropsI {
    name: string;
    showModal: boolean;
    onClose : ()=>void;
    onBack: ()=>void;
}

const InviteSuccessModal = ({ showModal, name, onClose, onBack }: PropsI) => {
    return (
        <Modal
            showModal={showModal}
            onClose={onClose}
            className="success-modal"
        >
            <img src={SuccessIcon} alt=""/>
            <div className="success-modal__text">
                <div className="success-modal__text--head">
                    Invite sent successfully!
                </div>
                <div className="success-modal__text--body">
                    Invite sent to {name}, you will be notify once the invite is accepted.
                </div>
            </div>
            <div className="block sm:flex justify-center">
                <button className="btn btn-outline" onClick={onClose}>
                    Invite later
                </button>
                <button className="btn btn-primary" onClick={onBack}>
                    Invite another friend
                </button>

            </div>
        </Modal>
    )
}
export default InviteSuccessModal;